import { Component, OnInit } from '@angular/core'
import { Router, NavigationStart } from '@angular/router'
import { Store } from '@ngrx/store'
import { filter } from 'rxjs/operators'
import { reduce } from 'lodash'
import { MenuService } from 'src/app/services/menu'

@Component({
  selector: 'vb-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
  menuData: any[]
  breadcrumbs: any[]

  constructor(
    private menuService: MenuService,
    private store: Store<any>,
    private router: Router,
  ) {}

  ngOnInit() {
    this.menuService.getMenuData().subscribe((menuData) => (this.menuData = menuData))
    var questionUrlMark = this.router.url
    var markQuestionUrl = questionUrlMark.split('?')
    markQuestionUrl.pop()
    if (markQuestionUrl[0] == undefined) {
      this.generateBreadcrumbs(this.router.url)
    } else {
      this.generateBreadcrumbs(markQuestionUrl[0])
    }
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        var questionMarkUrl = event.url
        var newUrlQuestionMark = questionMarkUrl.split('?')
        newUrlQuestionMark.pop()
        if (newUrlQuestionMark[0] == undefined) {
          this.generateBreadcrumbs(event.url)
        } else {
          this.generateBreadcrumbs(newUrlQuestionMark[0])
        }
      })
  }

  generateBreadcrumbs(event: any) {
    this.breadcrumbs = this.getPath(this.menuData, event).reverse()
  }

  getPath(data: any[], url: string, parents = []) {
    const items = reduce(
      data,
      (result: any, entry: any) => {
        if (result.length) {
          return result
        }
        if (entry.url === url) {
          return [entry].concat(parents)
        }
        if (entry.children) {
          const nested = this.getPath(entry.children, url, [entry].concat(parents))
          return (result || []).concat(nested.filter((e: any) => !!e))
        }
        return result
      },
      [],
    )
    return items.length > 0 ? items : [false]
  }
}
